import Ajax from '@utils/ajax';

export default {
  update(group, note, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/welcome_note/${note.id}`,
      data: { _method: 'PATCH', welcome_note: data },
      ...options,
    });
  },

  get(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/welcome_note`,
      ...options,
    });
  },

  toggle(group, enabled) {
    return Ajax.post({
      url: `/groups/${group.id}/welcome_note/toggle`,
      data: {
        _method: 'PATCH',
        group: { enabled: enabled },
      },
    });
  },
};
